import httpClient from '@/http-client'

export const loginInfo = (options = {}) => {
  return httpClient
    .get('/api/v1/login-out/login-info', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const logoutInfo = (options = {}) => {
  return httpClient
    .get('/api/v1/login-out/logout-info', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getUser = (options = {}) => {
  return httpClient
    .get('/api/v1/login-out/users', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { loginInfo, logoutInfo, getUser }
